import React, { useState } from "react";
import { LoaderIcon } from "lucide-react";
import { adFilms, series, hooks } from "../data/films";
import { FadeUp } from "./FadeUp";
const CAL_URL = "https://cal.com/brandhero/20min";
const CAL_EMBED_URL = `${CAL_URL}?embed=true&theme=dark&layout=month_view`;
const collage = [...adFilms, ...series, ...hooks];
export function SignupCta() {
  const [loaded, setLoaded] = useState(false);
  return <section id="book" className="relative scroll-mt-24 overflow-hidden py-24 md:py-32" aria-labelledby="cta-heading" data-id="element-346" data-mp="gegvq1jifxic">
      <div className="absolute inset-0 grid grid-cols-4 gap-2 opacity-10 grayscale md:grid-cols-8" aria-hidden="true" data-id="element-347" data-mp="bg6x1gykuerz">
        {[...collage, ...collage, ...collage].slice(0, 32).map((f, i) => <img key={`${f.id}-${i}`} src={f.image} alt="" loading="lazy" className="h-full min-h-[160px] w-full object-cover" data-id="element-348" data-mp="kdhbfb6oyk14" data-mpi={i} />)}
      </div>
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, rgba(15,15,15,0.55) 0%, #0F0F0F 75%)"
    }} aria-hidden="true" data-id="element-349" data-mp="1vufuwnb5gj6g" />

      <div className="container-x relative flex flex-col items-center text-center" data-id="element-350" data-mp="x7zs4n7sw51j">
        <FadeUp data-id="element-351" data-mp="x9ud21j2nx5m">
          <h2 id="cta-heading" className="font-serif text-[44px] leading-[0.98] tracking-[-0.02em] text-white sm:text-[clamp(52px,6vw,84px)]" data-id="element-352" data-mp="127cb2wvjwryu">
            Lights. Camera. <em className="italic text-signal" data-id="element-353" data-mp="175e3w9is45ni">Conversion.</em>
          </h2>
          <p className="mx-auto mt-5 max-w-[400px] text-[14px] leading-relaxed text-body md:text-[16px]" data-id="element-354" data-mp="9jq7hombpnbz">
            Tell us the film you thought was too big to make.
          </p>
        </FadeUp>

        <FadeUp className="mt-10 w-full max-w-[1040px] md:mt-12" data-id="element-355" data-mp="jft9muh6dlyx">
          <div className="border border-hairline bg-ink text-left" data-id="element-356" data-mp="o7tff3jxf93f">
            <div className="flex items-center justify-between border-b border-hairline px-4 py-3 font-mono text-[11px] tracking-[0.12em] md:px-5" data-id="element-357" data-mp="o94it29gmeu0">
              <span className="flex items-center gap-2 text-signal" data-id="element-358" data-mp="3rvmt9i6szdk7">
                <span className="rec-dot is-round inline-block h-1.5 w-1.5 bg-signal" aria-hidden="true" data-id="element-359" data-mp="3jvgq8n4b961a" />
                20-MIN FILM CALL
              </span>
              <a href={CAL_URL} target="_blank" rel="noreferrer" className="text-body transition-colors duration-150 hover:text-white" data-id="element-360" data-mp="3ftv56ehmhlg0">
                OPEN IN NEW TAB ↗
              </a>
            </div>
            <div className="relative h-[680px] md:h-[720px]" data-id="element-361" data-mp="30xm9fmwxxq8c">
              {!loaded && <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 font-mono text-[11px] tracking-[0.12em] text-foot" role="status" data-id="element-362" data-mp="2wwkjjwowyqj1">
                  <LoaderIcon className="h-5 w-5 animate-spin text-signal" aria-hidden="true" data-id="element-363" data-mp="35w783hwjo1uo" />
                  LOADING THE CALENDAR
                </div>}
              <iframe src={CAL_EMBED_URL} title="Book a 20-minute call with Brandhero" loading="lazy" onLoad={() => setLoaded(true)} className={`h-full w-full border-0 transition-opacity duration-200 ${loaded ? "opacity-100" : "opacity-0"}`} data-id="element-364" data-mp="q6w56y0kca5a" />
            </div>
          </div>
        </FadeUp>
      </div>
    </section>;
}